import type { CuratedItem, CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentOpinion";

export default function integrityCheck({
    items,
}: {
    items: CuratedItem[];
}): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items as CuratedStory[], [
        "headline",
        "byline",
    ]);

    messages.push(
        ...checkMediaIntegrity(
            firstItemOnly<CuratedItem>(items),
            MEDIA_PRIORITY
        )
    );

    return messages;
}
